module.exports = __webpack_public_path__ + "img/dp00.03ec2244.jpg";